












































import { Component, Vue } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import ApiSimulador from "@/plugins/ApiSimulador";
import RdStation from "@/plugins/RdStation";
import CheckIcon from "vue-material-design-icons/Check.vue";
import CancelIcon from "vue-material-design-icons/Cancel.vue";
import DadosTitular from "@/components/dados/DadosTitular.vue";
import DadosEmail from "@/components/dados/DadosEmail.vue";
import DadosDdd from "@/components/dados/DadosDdd.vue";
import DadosTelefone from "@/components/dados/DadosTelefone.vue";
import DadosCep from "@/components/dados/DadosCep.vue";
import DadosLogradouro from "@/components/dados/DadosLogradouro.vue";
import DadosNumero from "@/components/dados/DadosNumero.vue";
import DadosBairro from "@/components/dados/DadosBairro.vue";
import DadosCpf from "@/components/dados/DadosCpf.vue";
import DadosCartao from "@/components/dados/DadosCartao.vue";
import ShieldIcon from 'vue-material-design-icons/Shield.vue';
import ResumoProsseguir from "@/components/resumo/ResumoProsseguir.vue";

@Component({
  components: { CheckIcon,
        CancelIcon,
        DadosTelefone,
        DadosDdd,
        DadosTitular,
        DadosEmail,
        DadosCep,
        DadosLogradouro,
        DadosNumero,
        DadosBairro,
        DadosCpf,
        DadosCartao,
        ShieldIcon,
        ResumoProsseguir },
    computed:   {
        ...mapState(['cotacao']),
        ...mapGetters(['valor_mensalidade', 'veiculo_ano', 'get_email']),
    }
})
export default class Resumo extends Vue {
  public timeout = 0;

  public mounted() {
    this.$store.commit('SET_SIDEBAR_ENABLED', true);
    this.$store.commit("SET_SIDEBAR_SHOWING", this.$vuetify.breakpoint.smAndUp);
  }

  public beforeDestroy() {
     clearTimeout(this.timeout);
  }

  get protocolo() {
    return this.$store.state.cotacao.protocolo;
  }

  get preco() {
    return this.$store.getters.valor_fipe;
  }

  public sendInteresse ( interesse: boolean ) {
    const baseUrl = "//simulador.protruck.org.br/interesse";
    let pagina = '';

    let resposta = '';

    if (interesse) {
        resposta = 'Sim';
        pagina = "sim";
    } else {
        resposta = 'Não';
        pagina = "nao";
    }

    ApiSimulador.update({
      id: this.$store.state.cotacao.id,
      interesse: resposta,
    }).then(() => {
      RdStation.conversion({
        'identificador': `Interesse: ${resposta}` ,
        'Interesse em contratação': resposta,
        'email': this.$store.getters.get_email,
      }).then();
    });

    window.location.href = `${baseUrl}/${pagina}.php?id=${this.protocolo}`;
  }
}
